import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';
import errorBoundary from '@ifeng-fe/errorBoundary';

import { Event } from '@ifeng-fe/ui_base';
import { handleAd } from '@ifeng-fe/container_channel/common/client/winter/utils/handleAd';

class NavShare extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        ad: PropTypes.object,
    };
    constructor(props) {
        super(props);

        this.state = {
            hover1: false,
            hover2: false,
            hover3: false,
            data: [],
        };
    }

    onMouseEnter(index, e) {
        if (index === 0) {
            this.setState({
                hover1: true,
            });
        } else if (index === 1) {
            this.setState({
                hover2: true,
            });
        } else if (index === 2) {
            this.setState({
                hover3: true,
            });
        }
    }

    onMouseLeave() {
        this.setState({
            hover1: false,
            hover2: false,
            hover3: false,
        });
    }

    event = new Event();

    // insertArr 为广告方想要插入的一组位置，replaceArr 为广告方想要替换的一组位置，adFn 为回调方法
    insert = (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            const { data } = this.state;

            console.log('insertArr', insertArr); // 要插入的数据的索引
            console.log('replaceArr', replaceArr); // 被替换的数据的索引
            const infoData = [...data];
            const refs = [];

            // 广告插入，在指定位置后插入广告位数据
            insertArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 0, { type: 'ad', ref });
            });

            // 广告替换，在指定位置删除原数据，替换为广告位数据
            replaceArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 1, { type: 'ad', ref });
            });

            // 广告数据整合处理完毕后，更新列表数据
            this.setState(
                {
                    data: infoData,
                },
                () => {
                    const dom = {};

                    for (const ref of refs) {
                        dom[ref.index] = ref.ref.current;
                    }

                    adFn(dom);
                },
            );
        }

        return;
    };

    async componentDidMount() {
        // 插入软广
        try {
            const { ad } = this.props;

            // const ad = {
            //     data: {},
            //     preload: '',
            //     callback: (data, event, insert) => {
            //         // event 为传入的 event 事件对象，用于广告方绑定事件
            //         // insert 为我们自定义的广告插入方法
            //         event.on('init', () => {
            //             // data 为我们触发方法时传参值
            //             const insertArr = [];

            //             const replaceArr = [];

            //             insert(insertArr, replaceArr, (dom) => {
            //                 console.log('dom__', dom);
            //             });
            //         });
            //     },
            // };

            const callback = await handleAd(ad);

            callback(ad.data, this.event, this.insert); // 将自定义广告插入方法传入，这样广���方即可调用
        } catch (e) {
            console.error(e);
        }

        try {
            const data = this.props.content;

            // console.log('data__', data);
            if (data) {
                this.setState(
                    {
                        data,
                    },
                    () => {
                        this.adInit(data); // 数据请求完毕，初始化时触发广告位插入方法，data 为可选的传参值
                    },
                );
            }
        } catch (e) {
            console.error(e);
        }
    }

    adInit = data => {
        // console.log('data.length__', data.length);
        try {
            this.event.trigger('init', { rec_len: data.length }); // 触发广告位插入方法
        } catch (e) {
            console.error(e);
        }
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;
        const { data } = this.state;
        const {
            state: { hover1, hover2, hover3 },
            onMouseEnter,
            onMouseLeave,
        } = this;

        // console.log('nav___', content);

        const navigation = data.map((item, index) => {
            if (item.type === 'ad') {
                return <li key={index} ref={item.ref} />;
            } else {
                return (
                    <li key={index}>
                        <a href={item.url} target=" _blank" rel={rel} title={item.title}>
                            {item.title}
                        </a>
                    </li>
                );
            }
        });

        return (
            <div id="navigation2" className={styles.box_nav}>
                <div className={styles.h_sub_nav}>
                    <div className={styles.col_w1000}>
                        <ul className="clearfix">{navigation}</ul>
                        <div className={styles.share}>
                            <div
                                className={`${styles.e_nav} ${styles.e_icon}`}
                                onMouseEnter={onMouseEnter.bind(this, 0)}
                                onMouseLeave={onMouseLeave.bind(this)}>
                                <img src="https://y1.ifengimg.com/home/image/ewm01.jpg" alt="" id="e1" />
                                {hover1 ? <div className={`${styles.qrcode} ${styles.kehu}`} ref="nav1" /> : null}
                            </div>
                            <div
                                className={`${styles.e_nav} ${styles.e_icon}`}
                                onMouseEnter={onMouseEnter.bind(this, 1)}
                                onMouseLeave={onMouseLeave.bind(this)}>
                                <img
                                    src="https://p1.ifengimg.com/a/2018/0209/be46608c02b5056size2_w98_h35.jpg"
                                    alt=""
                                    id="e2"
                                />
                                {hover2 ? (
                                    <div className={`${styles.qrcode} ${styles.jiaju}`}>
                                        <img src="https://p3.ifengimg.com/a/2018/0209/dfba032a367282asize21_w120_h120.jpg" />
                                    </div>
                                ) : null}
                            </div>
                            <div
                                className={styles.e_nav}
                                onMouseEnter={onMouseEnter.bind(this, 2)}
                                onMouseLeave={onMouseLeave.bind(this)}>
                                <img
                                    src="https://p1.ifengimg.com/a/2018/0209/311cfa461dd0d89size2_w80_h35.jpg"
                                    alt=""
                                    id="e3"
                                />
                                {hover3 ? (
                                    <div className={`${styles.qrcode} ${styles.sheji}`}>
                                        <img src="https://p3.ifengimg.com/a/2018/0209/dc751f0bc383deasize19_w120_h120.jpg" />
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(NavShare);
